module.exports = __webpack_public_path__ + "img/sin-cuotas-pendientes.ac246f09.svg";